import gql from "graphql-tag";

const CREATE_CAMPAIGN_ORDER_NOTIFICATION = gql`
  mutation campaignOrderCreateNotifications($orgID: ID!, $message: String!) {
    campaignOrderCreateNotifications(data: { orgId: $orgID, message: $message })
  }
`;

export default CREATE_CAMPAIGN_ORDER_NOTIFICATION;
